var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from './link';
import { PrimaryStyles } from '../Button/primary';
var PrimaryButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), PrimaryStyles);
export default PrimaryButton;
var templateObject_1;
//# sourceMappingURL=primaryButton.js.map